import type { DeliverySelection } from './deliveryQuote';

export function describeCheckoutDeliveryChange(
  companyId: string,
  activeStoreId: string | null,
  previous: DeliverySelection,
  current: DeliverySelection
): string | null {
  if (!activeStoreId) {
    return 'Não foi possível identificar a loja ativa. Reabra o cardápio e confira o pedido. Referência: FC2-LOJA-AUSENTE.';
  }
  if (activeStoreId !== companyId) {
    return 'A loja ativa não corresponde à loja deste pedido. Reabra o cardápio da loja desejada e confira o pedido. Referência: FC2-LOJA-DIVERGENTE.';
  }

  const wasPickup = previous.endereco === 'RETIRADA';
  const isPickup = current.endereco === 'RETIRADA';
  const changes: string[] = [];
  const references: string[] = [];
  const add = (label: string, reference: string) => {
    changes.push(label);
    references.push(reference);
  };

  if (wasPickup !== isPickup) add(isPickup ? 'opção de entrega para retirada' : 'opção de retirada para entrega', 'FC2-MODALIDADE');
  else if (previous.endereco !== current.endereco) add('endereço', 'FC2-ENDERECO');
  // Bairro e coordenadas do cliente só influenciam pedidos de entrega.
  if (!wasPickup && !isPickup) {
    if (previous.bairro !== current.bairro) add('bairro', 'FC2-BAIRRO');
    if (previous.latitude !== current.latitude || previous.longitude !== current.longitude) add('localização', 'FC2-LOCALIZACAO');
  }
  if (previous.agendamento?.data !== current.agendamento?.data
    || previous.agendamento?.hora !== current.agendamento?.hora
    || Boolean(previous.agendamento) !== Boolean(current.agendamento)) add('agendamento', 'FC2-AGENDAMENTO');

  if (!changes.length) return null;
  const context = wasPickup && isPickup ? 'da retirada' : 'do pedido';
  return `Mudança durante a validação ${context}: ${changes.join(', ')}. Revise o pedido antes de confirmar. Referência: ${references.join(', ')}.`;
}
